import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface Message {
  name: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  private messageSubject: Subject<Message> = new Subject<Message>();

  public sendMessage(message: Message): void {
    this.messageSubject.next(message);
  }

  public getMessages(): Observable<Message> {
    return this.messageSubject.asObservable();
  }
}
